import { ButtonGroup } from '@qga/roo-ui/components';
import { useBookingList } from '../BookingListProvider';
import * as tracking from 'lib/gaTracking/bookingListPageEvents';

interface ExtraButtonGroupProps {
  [key: string]: any;
}

const Filter = (props: ExtraButtonGroupProps) => {
  const { options, filter, update } = useBookingList();
  const onChange = (value: string) => {
    tracking.filterBookingList(value);
    update(value);
  };

  return <ButtonGroup name="filter" value={filter} options={options} onChange={onChange} {...props} />;
};

export default Filter;
